import React, { useEffect, useRef, useState } from 'react';
import { Toast } from 'primereact/toast';
import { Controller, useForm } from 'react-hook-form';
import { CircularProgress, TextField } from '@mui/material';
import MuiSelect from '../ogComponent/muiSelect';
import axios from 'axios';
import Select from 'react-select';
import BasicTabs from '../ogComponent/muiTabs';
import { useParams, useNavigate } from 'react-router-dom';

export default function EditEmployee() {
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      employee_code: "",
      profile_photo: "",
      nationality: "",
      blood_group: "",
      education_level: "",
      password: "",
      gender: "",
      employee_type: "",
      marital_status: "",
      work_experience: "",
      status: "",
      phone_number: "",
      email: "",
      branch: null,
      job_type: null,
      type_of_salary: null,
      department: null,
      job_position: null,
      shift: null,
      joined_date: "",
      end_of_probation: "",
      effective_date: "",
      basic_salary: "",
      currency: "",
      benifits: "",
      bonus: "",
      deduction: "",
      city: "",
      state: "",
      pincode: "",
      office_phone: "",
      relative_name: "",
      relation: "",
      rel_phone_number: "",
      address_1: "",
      address_2: "",
      hr_to: [],
      reporting_to: [],
      roles: [],
      accHolder: "",
      accNumber: "",
      ifsccode: "",
      bankName: "",
      branchName: "",
      passportPhoto: null,
      sslcfile: null,
      adharfile: null,
      pancard: null,
      passportPhotoUrl: "",
      sslcUrl: "",
      adharUrl: "",
      pancardUrl: "",
    },
  });

  const [selectedImage, setSelectedImage] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [currentProfilePhoto, setCurrentProfilePhoto] = useState(null);
  const Genoptions = [{ name: "Male" }, { name: "Female" }, { name: "Other" }];
  const employeeOptions = [{ name: "Employee" }, { name: "Intern" }, { name: "Student" }];
  const [branches, setBranches] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [isDepartmentDisabled, setDepartmentDisabled] = useState(true);
  const [jobPositions, setJobPositions] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedPosition, setSelectedPosition] = useState(null);
  const [shifts, setShifts] = useState([]);
  const [selectedJobType, setSelectedJobtype] = useState({});
  const [selectedSalaryType, setSelectedSalaryType] = useState({});
  const [isJobPositionDisabled, setJobPositionDisabled] = useState(true);
  const [hrPositions, setHrpositions] = useState([]);
  const [reportingOptions, setReportingOptions] = useState([]);
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [jobTypes, setJobTypes] = useState([]);
  const [salaryTypes, setSalaryTypes] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [employeeData, setEmployeeData] = useState(null);
  const { emp_id } = useParams();
  const [error, setError] = useState(null);
  const token = localStorage.getItem("accessToken");
  const toast = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEmployeeData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API}/api/account/users-list/${emp_id}/`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setEmployeeData(response.data);
      } catch (error) {
        console.error("Error fetching employee data:", error);
      }
    };

    if (emp_id) {
      fetchEmployeeData();
    }
  }, [emp_id, token]);

  useEffect(() => {
    if (employeeData) {
      setValue('name', employeeData.name || "");
      setValue('employee_code', employeeData.employee_code || "");
      setValue('email', employeeData.email || "");
      setValue('phone_number', employeeData.phone_number || "");
      setValue('nationality', employeeData.nationality || "");
      setValue('gender', employeeData.gender || "");
      setValue('employee_type', employeeData.employee_type || "");
      setValue('blood_group', employeeData.blood_group || "");
      setValue('education_level', employeeData.education_level || "");
      setValue('marital_status', employeeData.marital_status || "");
      setValue('work_experience', employeeData.work_experience || "");
      setValue('status', employeeData.status ? "Active" : "In-Active");
      setValue('joined_date', employeeData.joined_date || "");
      setValue('end_of_probation', employeeData.end_of_probation || "");
      setValue('effective_date', employeeData.effective_date || "");
      setValue('currency', employeeData.currency || "");
      setValue('benifits', employeeData.benifits || "");
      setValue('bonus', employeeData.bonus || "");
      setValue('deduction', employeeData.deduction || "");
      setValue('city', employeeData.city || "");
      setValue('state', employeeData.state || "");
      setValue('pincode', employeeData.pincode || "");
      setValue('office_phone', employeeData.office_phone || "");
      setValue('relative_name', employeeData.relative_name || "");
      setValue('relation', employeeData.relation || "");
      setValue('rel_phone_number', employeeData.rel_phone_number || "");
      setValue('address_1', employeeData.address_1 || "");
      setValue('address_2', employeeData.address_2 || "");
      setValue('basic_salary', employeeData.basic_salary || "");
      setValue('profile_photo', employeeData.profile_photo || "");
      setCurrentProfilePhoto(employeeData.profile_photo);
      setSelectedImage(employeeData.profile_photo || null);

      if (employeeData.bank_details && employeeData.bank_details.length > 0) {
        const bank = employeeData.bank_details[0];
        setValue('accHolder', bank.account_holder_name || "");
        setValue('accNumber', bank.account_number || "");
        setValue('ifsccode', bank.ifsc_code || "");
        setValue('bankName', bank.bank_name || "");
        setValue('branchName', bank.branch_name || "");
      }

      if (employeeData.documents && employeeData.documents.length > 0) {
        employeeData.documents.forEach(doc => {
          if (doc.document_type === "passportPhoto") {
            setValue('passportPhotoUrl', doc.file || "");
          } else if (doc.document_type === "sslc") {
            setValue('sslcUrl', doc.file || "");
          } else if (doc.document_type === "adhar") {
            setValue('adharUrl', doc.file || "");
          } else if (doc.document_type === "pancard") {
            setValue('pancardUrl', doc.file || "");
          }
        });
      }

      handleSelectFields(employeeData);
    }
  }, [employeeData, setValue, branches, jobTypes, salaryTypes, hrPositions, reportingOptions, roles, jobPositions]);

  const handleSelectFields = (employeeData) => {
    // Branch
    if (branches.length) {
      const currentBranchId = getValues('branch')?.value;
      const originalBranchId = employeeData.branch?.id || employeeData.branch;
      if (currentBranchId == null || currentBranchId === originalBranchId) {
        const selectedBranchObj = branches.find(branch => branch.id === originalBranchId);
        if (selectedBranchObj) {
          setValue('branch', { value: selectedBranchObj.id, label: selectedBranchObj.name });
          setSelectedBranch({ value: selectedBranchObj.id, label: selectedBranchObj.name });
        }
      }
    }

    // Department
    if (departments.length) {
      const currentDeptId = getValues('department')?.value;
      const originalDeptId = employeeData.department?.id || employeeData.department;
      if (currentDeptId == null || currentDeptId === originalDeptId) {
        const selectedDept = departments.find(dept => dept.id === originalDeptId);
        if (selectedDept) {
          setValue('department', { value: selectedDept.id, label: selectedDept.name });
          setSelectedDepartment({ value: selectedDept.id, label: selectedDept.name });
        }
      }
    }

    // Job Position
    if (jobPositions.length) {
      const currentPosId = getValues('job_position')?.value;
      const originalPosId = employeeData.job_position?.id || employeeData.job_position;
      if (currentPosId == null || currentPosId === originalPosId) {
        const selectedPosition = jobPositions.find(pos => pos.value === originalPosId);
        if (selectedPosition) {
          setValue('job_position', selectedPosition);
          setSelectedPosition(selectedPosition);
        }
      }
    }

    // Job Type
    if (jobTypes.length) {
      const currentJobTypeId = getValues('job_type')?.value;
      const originalJobTypeId = employeeData.job_type?.id || employeeData.job_type;
      if (currentJobTypeId == null || currentJobTypeId === originalJobTypeId) {
        const selectedJobType = jobTypes.find(type => type.value === originalJobTypeId);
        if (selectedJobType) {
          setSelectedJobtype(selectedJobType);
          setValue('job_type', { value: selectedJobType.value, label: selectedJobType.label });
        }
      }
    }

    // Salary Type
    if (salaryTypes.length) {
      const currentSalaryTypeId = getValues('type_of_salary')?.value;
      const originalSalaryTypeId = employeeData.type_of_salary?.id || employeeData.type_of_salary;
      if (currentSalaryTypeId == null || currentSalaryTypeId === originalSalaryTypeId) {
        const selectedSalaryType = salaryTypes.find(type => type.value === originalSalaryTypeId);
        if (selectedSalaryType) {
          setSelectedSalaryType(selectedSalaryType);
          setValue('type_of_salary', { value: selectedSalaryType.value, label: selectedSalaryType.label });
        }
      }
    }

    // Shift
    if (shifts.length) {
      const currentShiftId = getValues('shift')?.value;
      const originalShiftId = employeeData.shift?.id || employeeData.shift;
      if (currentShiftId == null || currentShiftId === originalShiftId) {
        const selectedShift = shifts.find(shift => shift.value === originalShiftId);
        if (selectedShift) {
          setValue('shift', { value: selectedShift.value, label: selectedShift.name });
        }
      }
    }

    // HR To (Multi)
    if (hrPositions.length && employeeData.hr_to?.length) {
      const current = getValues('hr_to') || [];
      const originalIds = employeeData.hr_to.map(item => item.id || item);
      const currentIds = current.map(item => item.value);
      const isOriginal = currentIds.length === 0 || JSON.stringify(currentIds.sort()) === JSON.stringify(originalIds.sort());
      if (isOriginal) {
        const selectedHr = hrPositions.filter(hr => originalIds.includes(hr.value));
        if (selectedHr.length) {
          setValue('hr_to', selectedHr);
        }
      }
    }

    // Reporting To (Multi)
    if (reportingOptions.length && employeeData.reporting_to?.length) {
      const current = getValues('reporting_to') || [];
      const originalIds = employeeData.reporting_to.map(item => item.id || item);
      const currentIds = current.map(item => item.value);
      const isOriginal = currentIds.length === 0 || JSON.stringify(currentIds.sort()) === JSON.stringify(originalIds.sort());
      if (isOriginal) {
        const selectedReporting = reportingOptions.filter(rep => originalIds.includes(rep.value));
        if (selectedReporting.length) {
          setValue('reporting_to', selectedReporting);
        }
      }
    }

    // Roles (Multi)
    if (roles.length && employeeData.roles?.length) {
      const current = getValues('roles') || [];
      const originalIds = employeeData.roles.map(item => item.id || item);
      const currentIds = current.map(item => item.value);
      const isOriginal = currentIds.length === 0 || JSON.stringify(currentIds.sort()) === JSON.stringify(originalIds.sort());
      if (isOriginal) {
        const selectedRoles = roles.filter(role => originalIds.includes(role.value));
        if (selectedRoles.length) {
          setValue('roles', selectedRoles);
        }
      }
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const config = { headers: { Authorization: `Bearer ${token}` } };
        const [branchesResponse, rolesResponse, jobTypesResponse, salaryTypesResponse, shiftResponse] = await Promise.all([
          axios.get(`${process.env.REACT_APP_API}/api/employee/branches/`, config),
          axios.get(`${process.env.REACT_APP_API}/api/common/roles/`, config),
          axios.get(`${process.env.REACT_APP_API}/api/employee/jobtypes/`, config),
          axios.get(`${process.env.REACT_APP_API}/api/employee/salarytypes/`, config),
          axios.get(`${process.env.REACT_APP_API}/api/employee/shifts/`, config),
        ]);

        setBranches(branchesResponse.data.map(branch => ({ name: `${branch.branch_name} - ${branch.location}`, id: branch.id })));
        setRoles(rolesResponse.data.map(role => ({ value: role.id, label: role.role_name })));
        setJobTypes(jobTypesResponse.data.map(item => ({ value: item.id, label: item.job_type })));
        setSalaryTypes(salaryTypesResponse.data.map(item => ({ value: item.id, label: item.type_of_salary })));
        setShifts(shiftResponse.data.map(item => ({
          value: item.id,
          name: item.shift_name,
          label: item.shift_name,
        })));
      } catch (error) {
        console.error("Error fetching data:", error);
        setError('Failed to fetch necessary data. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [token]);

  useEffect(() => {
    const fetchReportingOptions = async () => {
      try {
        const config = { headers: { Authorization: `Bearer ${token}` } };
        const response = await axios.get(`${process.env.REACT_APP_API}/api/account/users-list/`, config);
        setReportingOptions(
          response.data.map(user => ({
            value: user.id,
            label: user.name,
          }))
        );
      } catch (error) {
        console.error("Error fetching reporting options:", error);
        setError("Failed to fetch reporting options. Please try again later.");
      }
    };

    fetchReportingOptions();
  }, [token]);

  useEffect(() => {
    const handleBranchChange = async (branchId) => {
      setDepartmentDisabled(true);
      setJobPositionDisabled(true);
      setDepartments([]);
      setJobPositions([]);
      setValue('department', null);
      setSelectedDepartment(null);
      setValue('job_position', null);
      setSelectedPosition(null);
      setValue('hr_to', []); // Clear HR to when branch changes

      try {
        const config = { headers: { Authorization: `Bearer ${token}` } };

        // Fetch departments
        const deptResponse = await axios.get(
          `${process.env.REACT_APP_API}/api/employee/departments/?branches=${branchId}`,
          config
        );
        const departments = deptResponse.data.map(dept => ({ name: dept.dep_name, id: dept.id }));
        setDepartments(departments);
        if (departments.length && employeeData) {
          const selectedDept = departments.find(dept => dept.id === employeeData.department?.id);
          if (selectedDept) {
            setValue('department', { value: selectedDept.id, label: selectedDept.name });
            setSelectedDepartment({ value: selectedDept.id, label: selectedDept.name });
          }
        }
        setDepartmentDisabled(false);

        // Fetch HR employees for the selected branch
        const hrResponse = await axios.get(
          `${process.env.REACT_APP_API}/api/account/hr-employees?branch_id=${branchId}`,
          config
        );
        const hrEmployees = hrResponse.data.map(emp => ({
          value: emp.id,
          label: emp.name,
        }));
        setHrpositions(hrEmployees);

        // Re-populate HR to if employeeData exists and has hr_to
        if (employeeData && employeeData.hr_to?.length) {
          const originalIds = employeeData.hr_to.map(item => item.id || item);
          const selectedHr = hrEmployees.filter(hr => originalIds.includes(hr.value));
          if (selectedHr.length) {
            setValue('hr_to', selectedHr);
          }
        }
      } catch (error) {
        console.error("Error fetching departments or HR employees:", error);
        setError('Failed to fetch departments or HR employees. Please try again later.');
      }
    };

    if (selectedBranch?.value) {
      handleBranchChange(selectedBranch?.value);
    }
  }, [selectedBranch?.value, employeeData, setValue, token]);

  useEffect(() => {
    const handleDepartmentChange = async (deptId) => {
      setJobPositionDisabled(true);
      setJobPositions([]);
      setValue('job_position', null);
      setSelectedPosition(null);

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API}/api/employee/jobpositions/?department=${deptId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const jobPositions = response.data.map(pos => ({
          value: pos.id,
          label: pos.job_title,
        }));
        setJobPositions(jobPositions);
        setJobPositionDisabled(false);
        if (jobPositions.length && employeeData) {
          const selectedPosition = jobPositions.find(pos => pos.value === employeeData.job_position?.id);
          if (selectedPosition) {
            setValue('job_position', selectedPosition);
            setSelectedPosition(selectedPosition);
          }
        }
      } catch (error) {
        console.error("Error fetching job positions:", error);
        setError('Failed to fetch job positions. Please try again later.');
      }
    };

    if (selectedDepartment?.value) {
      handleDepartmentChange(selectedDepartment?.value);
    }
  }, [selectedDepartment?.value, employeeData, setValue, token]);

  const handleReset = () => {
    reset();
    setSelectedImage(null);
    setSelectedBranch(null);
    setSelectedDepartment(null);
    setSelectedPosition(null);
  };

  const SelectStyle = {
    control: (base, state) => ({
      ...base,
      minHeight: '38px',
      maxHeight: '38px',
      overflow: 'hidden',
    }),
    valueContainer: (base) => ({
      ...base,
      maxHeight: '38px',
      overflow: 'auto',
      flexWrap: 'nowrap',
      '&::-webkit-scrollbar': {
        width: '4px',
        height: '4px',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      padding: '2px 8px',
    }),
    multiValue: (base) => ({
      ...base,
      flexShrink: 0,
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
    }),
  };

  const onSubmit = async (data) => {
    setIsSubmitting(true);
    console.log("Form Data:", data);
    try {
      const formData = new FormData();
      const originalData = employeeData;

      const hasChanged = (newValue, originalValue) => {
        if (Array.isArray(newValue) && Array.isArray(originalValue)) {
          return JSON.stringify(newValue.map(item => item.value)) !==
            JSON.stringify(originalValue.map(item => item.id || item));
        }
        if (typeof newValue === 'object' && newValue !== null && originalValue) {
          return newValue.value !== (originalValue.id || originalValue);
        }
        return newValue !== originalValue;
      };

      const fieldsToCheck = {};

      const statusValue = data.status ? data.status === "Active" : false;
      if (hasChanged(statusValue, originalData.status)) {
        fieldsToCheck.status = statusValue;
      }

      const fields = {
        name: data.name || "",
        employee_code: data.employee_code || "",
        nationality: data.nationality || "",
        blood_group: data.blood_group || "",
        education_level: data.education_level || "",
        gender: data.gender?.name || data.gender || "",
        employee_type: data.employee_type?.name || data.employee_type || "",
        marital_status: data.marital_status || "",
        work_experience: data.work_experience || "",
        phone_number: data.phone_number || "",
        email: data.email || "",
        shift: data.shift?.value || "",
        branch: data.branch?.value || "",
        job_type: data.job_type?.value || "",
        type_of_salary: data.type_of_salary?.value || "",
        department: data.department?.value || "",
        job_position: data.job_position?.value || "",
        joined_date: data.joined_date || "",
        end_of_probation: data.end_of_probation || "",
        effective_date: data.effective_date || "",
        basic_salary: data.basic_salary || "",
        currency: data.currency || "",
        benifits: data.benifits || "",
        bonus: data.bonus || "",
        deduction: data.deduction || "",
        city: data.city || "",
        state: data.state || "",
        pincode: data.pincode || "",
        office_phone: data.office_phone || "",
        relative_name: data.relative_name || "",
        relation: data.relation || "",
        rel_phone_number: data.rel_phone_number || "",
        address_1: data.address_1 || "",
        address_2: data.address_2 || "",
        'bank_details[0][account_holder_name]': data.accHolder || "",
        'bank_details[0][account_number]': data.accNumber || "",
        'bank_details[0][ifsc_code]': data.ifsccode || "",
        'bank_details[0][bank_name]': data.bankName || "",
        'bank_details[0][branch_name]': data.branchName || "",
      };

      Object.entries(fields).forEach(([key, value]) => {
        const originalValue = key.includes('bank_details')
          ? originalData.bank_details?.[0]?.[key.split('.').pop()]
          : key === 'job_position'
          ? (originalData[key]?.id || originalData[key])
          : originalData[key];
        if (hasChanged(value, originalValue)) {
          fieldsToCheck[key] = value;
        }
      });

      Object.entries(fieldsToCheck).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          formData.append(key, value);
        }
      });

      if (imageFile) {
        formData.append('profile_photo', imageFile);
      }

      const documents = [
        { type: 'passportPhoto', file: data.passportPhoto },
        { type: 'sslc', file: data.sslcfile },
        { type: 'adhar', file: data.adharfile },
        { type: 'pancard', file: data.pancard },
      ];

      documents.forEach((doc, index) => {
        if (doc.file) {
          formData.append(`documents[${index}].document_type`, doc.type);
          formData.append(`documents[${index}].file`, doc.file);
        }
      });

      // Handle HR To - append all current selections (including empty for removal)
      if (hasChanged(data.hr_to || [], originalData.hr_to || [])) {
        if (data.hr_to && data.hr_to.length > 0) {
          data.hr_to.forEach((hr) => {
            formData.append(`hr_to`, hr.value);
          });
        } else {
          // Explicitly send empty for removal
          formData.append(`hr_to`, '[]');
        }
      }

      if (data.reporting_to && hasChanged(data.reporting_to, originalData.reporting_to)) {
        data.reporting_to.forEach((report) => {
          formData.append(`reporting_to`, report.value);
        });
      }

      if (data.roles && hasChanged(data.roles, originalData.roles)) {
        data.roles.forEach((role) => {
          formData.append(`roles`, role.value);
        });
      }

      if (formData.entries().next().done) {
        toast.current.show({
          severity: 'info',
          summary: 'No Changes',
          detail: 'No changes were made to the employee data',
          life: 3000,
        });
        setIsSubmitting(false);
        return;
      }

      const response = await axios.patch(
        `${process.env.REACT_APP_API}/api/account/users/${emp_id}/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (response.status === 200) {
        toast.current.show({
          severity: 'success',
          summary: 'Success',
          detail: 'Employee updated successfully',
          life: 3000,
        });
        navigate('/user/emp');
      }
    } catch (error) {
      console.error('Error updating employee:', error);
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: error.response?.data?.message || 'Failed to update employee',
        life: 3000,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSelectImage = () => {
    document.getElementById("employee-image-input").click();
  };

  const handleImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      setImageFile(file);
      setValue('profile_photo', file);
      const reader = new FileReader();
      reader.onload = (e) => {
        setSelectedImage(e.target.result);
      };
      reader.readAsDataURL(file);
    } else {
      setSelectedImage(currentProfilePhoto);
      setImageFile(null);
      setValue('profile_photo', currentProfilePhoto);
    }
  };

  return (
    <>
      <div className='editEmpContainer w-100 h-100 px-lg-5 py-lg-4 p-sm-1'>
        <Toast ref={toast} position="bottom-right" />
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="formContainer w-100 h-100 d-flex gap-4 flex-column"
          style={{ backgroundColor: "#5853b70d" }}
        >
          <div className="firstContainer w-100 d-flex justify-content-center align-items-center">
            <div className="imageUploaderside d-flex justify-content-center align-items-center">
              <div className="image-uploader">
                {selectedImage ? (
                  <div className="selected-image-container">
                    <img
                      src={selectedImage}
                      alt="Selected Employee Img"
                      className="selected-image"
                    />
                  </div>
                ) : (
                  <div className="upload-image-container">
                    <img
                      src="https://icons.veryicon.com/png/o/internet--web/prejudice/user-128.png"
                      alt=""
                      className="w-100 h-100"
                    />
                  </div>
                )}
                <button
                  type="button"
                  className="select-image-button"
                  onClick={handleSelectImage}
                >
                  <i className="pen-icon fas fa-pen"></i>
                  Select Image
                </button>
                <input
                  type="file"
                  id="employee-image-input"
                  accept="image/*"
                  onChange={handleImageChange}
                  style={{ display: "none" }}
                />
              </div>
            </div>
            <div className="dataSide d-grid w-100">
              <div className="SingleData">
                <Controller
                  name="name"
                  control={control}
                  rules={{ required: true }}
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      {...field}
                      className="form-control"
                      label="Name"
                      variant="outlined"
                      size="small"
                      placeholder="Reni Thomas"
                      error={!!error}
                      helperText={error?.message}
                      InputProps={{ sx: { height: "35px" } }}
                    />
                  )}
                />
              </div>
              <div className="SingleData">
                <Controller
                  name="employee_code"
                  control={control}
                  rules={{ required: true }}
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      {...field}
                      className="form-control"
                      label="Emp Code"
                      variant="outlined"
                      size="small"
                      placeholder="0001"
                      disabled
                      error={!!error}
                      helperText={error?.message}
                      InputProps={{ sx: { height: "35px" } }}
                    />
                  )}
                />
              </div>
              <div className="SingleData">
                <Controller
                  name="phone_number"
                  control={control}
                  rules={{
                    required: true,
                    pattern: {
                      value: /^\+?[1-9]\d{1,14}$/,
                      message: "Invalid phone number",
                    },
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      {...field}
                      type="tel"
                      className="form-control"
                      label="Phone Number"
                      variant="outlined"
                      size="small"
                      placeholder="+91 1234567890"
                      error={!!error}
                      helperText={error?.message}
                      InputProps={{ sx: { height: "35px" } }}
                    />
                  )}
                />
              </div>
              <div className="SingleData">
                <Controller
                  name="email"
                  control={control}
                  rules={{
                    required: true,
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: "Invalid email address",
                    },
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      {...field}
                      type="email"
                      className="form-control"
                      label="Email"
                      variant="outlined"
                      size="small"
                      placeholder="abcd@gmail.com"
                      error={!!error}
                      helperText={error?.message}
                      InputProps={{ sx: { height: "35px" } }}
                    />
                  )}
                />
              </div>
              <div className="SingleData">
                <Controller
                  name="gender"
                  control={control}
                  rules={{ required: true }}
                  render={({ field, fieldState: { error } }) => (
                    <MuiSelect
                      {...field}
                      label="Gender"
                      options={Genoptions}
                      className={`bg-white z-index-10`}
                      error={!!error}
                      helperText={error?.message}
                    />
                  )}
                />
              </div>
              <div className="SingleData">
                <Controller
                  name="employee_type"
                  control={control}
                  rules={{ required: false }}
                  render={({ field, fieldState: { error } }) => (
                    <MuiSelect
                      {...field}
                      label="Emp Type"
                      options={employeeOptions}
                      className={`bg-white z-index-10`}
                      error={!!error}
                      helperText={error?.message}
                    />
                  )}
                />
              </div>
              <div className="SingleData">
                <div className='position-relative'>
                  <label htmlFor="branch-select" className='position-absolute z-3 bg-light' style={{ fontSize: '10px', top: '-8px', left: '10px' }}>Branch</label>
                  <Controller
                    name="branch"
                    control={control}
                    render={({ field: { onChange, value, ...rest } }) => (
                      <Select
                        {...rest}
                        id="branch-select"
                        options={branches.map(branch => ({ value: branch.id, label: branch.name }))}
                        isDisabled={loading}
                        onChange={(selectedOption) => {
                          onChange(selectedOption);
                          setSelectedBranch(selectedOption);
                        }}
                        value={selectedBranch}
                        styles={SelectStyle}
                      />
                    )}
                  />
                </div>
              </div>
              <div className="SingleData">
                <div className='position-relative'>
                  <label htmlFor="department-select" className='position-absolute z-3 bg-light' style={{ fontSize: '10px', top: '-8px', left: '10px' }}>Department</label>
                  <Controller
                    name="department"
                    control={control}
                    rules={{ required: true }}
                    render={({ field: { onChange, value, ...rest } }) => (
                      <Select
                        {...rest}
                        id="department-select"
                        options={departments.map(dept => ({ value: dept.id, label: dept.name }))}
                        className="bg-white"
                        isDisabled={isDepartmentDisabled}
                        onChange={(selectedOption) => {
                          onChange(selectedOption);
                          setSelectedDepartment(selectedOption);
                        }}
                        value={selectedDepartment}
                        styles={SelectStyle}
                      />
                    )}
                  />
                </div>
              </div>
              <div className="SingleData">
                <div className='position-relative'>
                  <label htmlFor="job-position-select" className='position-absolute z-3 bg-light' style={{ fontSize: '10px', top: '-8px', left: '10px' }}>Job Position</label>
                  <Controller
                    name="job_position"
                    control={control}
                    rules={{ required: true }}
                    render={({ field: { onChange, value, ...rest } }) => (
                      <Select
                        {...rest}
                        id="job-position-select"
                        options={jobPositions}
                        className="bg-white"
                        isDisabled={isJobPositionDisabled}
                        onChange={(selectedOption) => {
                          onChange(selectedOption);
                          setSelectedPosition(selectedOption);
                        }}
                        value={value}
                        styles={SelectStyle}
                      />
                    )}
                  />
                </div>
              </div>
              <div className="SingleData">
                <div className='position-relative'>
                  <label htmlFor="shift-select" className='position-absolute z-3 bg-light' style={{ fontSize: '10px', top: '-8px', left: '10px' }}>Shift</label>
                  <Controller
                    name="shift"
                    control={control}
                    rules={{ required: "Shift is required" }}
                    render={({ field: { onChange, value, ...rest } }) => (
                      <Select
                        {...rest}
                        id="shift-select"
                        options={shifts.map(shift => ({ value: shift.value, label: shift.name }))}
                        className={`bg-white ${errors.shift ? "error-border" : ""}`}
                        isDisabled={loading}
                        onChange={(selectedOption) => {
                          onChange(selectedOption);
                        }}
                        value={value}
                        styles={SelectStyle}
                      />
                    )}
                  />
                </div>
              </div>
              <div className="SingleData">
                <div className='position-relative'>
                  <label htmlFor="hr_to" className='position-absolute z-3 bg-light' style={{ fontSize: '10px', top: '-8px', left: '10px' }}>Hr to</label>
                  <Controller
                    name="hr_to"
                    control={control}
                    render={({ field: { onChange, value, ...rest } }) => (
                      <Select
                        {...rest}
                        id="hr_to"
                        options={hrPositions}
                        className={`bg-white z-index-10 ${errors.hr_to ? "error-border" : ""}`}
                        isMulti
                        placeholder="Hr to"
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value}
                        onChange={(selectedOptions) => onChange(selectedOptions || [])}
                        value={value || []}
                        styles={SelectStyle}
                      />
                    )}
                  />
                </div>
              </div>
              <div className="SingleData">
                <div className='position-relative'>
                  <label htmlFor="reporting_to" className='position-absolute z-3 bg-light' style={{ fontSize: '10px', top: '-8px', left: '10px' }}>Reporting to</label>
                  <Controller
                    name="reporting_to"
                    control={control}
                    render={({ field: { onChange, value, ...rest } }) => (
                      <Select
                        {...rest}
                        id="reporting_to"
                        options={reportingOptions}
                        className={`bg-white z-index-10 ${errors.reporting_to ? "error-border" : ""}`}
                        isMulti
                        placeholder="Reporting To"
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value}
                        onChange={(selectedOptions) => onChange(selectedOptions || [])}
                        value={value || []}
                        styles={SelectStyle}
                      />
                    )}
                  />
                </div>
              </div>
              <div className="SingleData rolesField">
                <div className='position-relative'>
                  <label htmlFor="roles" className='position-absolute z-3 bg-light' style={{ fontSize: '10px', top: '-8px', left: '10px' }}>Roles</label>
                  <Controller
                    name="roles"
                    control={control}
                    render={({ field }) => (
                      <Select
                        id='roles'
                        {...field}
                        options={roles}
                        className={`bg-white z-index-10 ${errors.roles ? "error-border" : ""}`}
                        isMulti
                        placeholder="Select Roles"
                        styles={SelectStyle}
                      />
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="containerCollapse w-100 d-flex flex-column gap-md-4">
            <BasicTabs
              tabs={["Personal Details", "Job Details", "Contact Details", "Bank Details", "Documents"]}
              control={control}
              jobTypes={jobTypes}
              salaryTypes={salaryTypes}
              selectedJobType={selectedJobType}
              selectedSalaryType={selectedSalaryType}
              type={"edit"}
            />
          </div>
          <div className="fifthContainer d-flex justify-content-end me-3 gap-md-4 gap-2 pe-md-5 pe-2">
            <button
              type="button"
              className="btn text-white btn-success"
              onClick={handleReset}
            >
              Reset
            </button>
            <button
              type="submit"
              className="btn text-white d-flex align-items-center justify-content-center"
              style={{ backgroundColor: "#120e4d", minWidth: "120px", height: "38px" }}
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <CircularProgress size={24} color="inherit" sx={{ mr: 1 }} />
                </>
              ) : (
                "Update"
              )}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}